import { DEVICE_TYPES } from '../interfaces/ISettings';
import { Language } from '../interfaces/Language';

export const APP_ID = 'frodo';
export const CONFIRMATION_TIME = 3000;

export const GATEWAY_SERVICES = {
  HELMSDEEP: 'helmsdeep',
  GANDALF: 'gandalf',
  FRODO_API: 'frodo-api',
  BABELFISH: 'babelfish',
} as const;
export const LOAD_ORDER_TIME = 5000;

export const SUPPORTED_LANGUAGES: Language[] = [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Español',
    code: 'es',
  },
  {
    name: 'Québécois',
    code: 'fr_CA',
  },
  {
    name: 'Polski',
    code: 'pl',
  },
];

export const SPACE_LABEL = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const TOAST_MESSAGE = 4000;
export enum TOAST_TYPES {
  Error = 'Error',
  Success = 'Success',
  Warning = 'Warning',
  Info = 'Info',
}
// Accepts both the TOAST_TYPES enum and its plain string values (e.g. 'Error').
export type SnackType = TOAST_TYPES | `${TOAST_TYPES}`;
export enum TTW_SCREEN {
  URL = '/ttw',
}
export enum FRONT_SCREEN {
  URL = '/front-loading',
}
export enum VIEW_TYPES {
  TTW = 'ttw',
  FRONT_LOADING = 'front-loading',
  REAR_LOADING = 'rear-loading',
  RETAIL = 'retail',
  SETUP = 'setup',
  DEVICE_SUSPENDED = 'device-suspended',
}
export enum RETAIL_SCREEN {
  URL = '/retail',
  STATUS = '/retail/status',
  CONFIRMATION = '/retail/confirmation',
}
export const PRESCRIPTIVE_FLOW = 'prescriptive';
export const FRICTIONLESS_FLOW = 'frictionless';
export const SCAN_TYPE = 'scan';
export const ORDER_ID_TYPE = 'order-id';
export const MOBILE_TYPE = 'mobile';
export const DELIVERY_LIST_TYPE = 'delivery-list';
export const DISPENSE_ORDERED = 'DISPENSE_ORDERED';
export const DISPENSE_READY = 'DISPENSE_READY';
export const DISPENSE_LOADING = 'DISPENSE_LOADING';
export const PRESENCE = 'presence';
export const UPDATE_LABELS = 'update-labels';
export const SPACE_ACTION_EVENT = 'space-action';
export const SPACE_RESET_EVENT = 'reset-space-action';
export const DOOR_CLOSED = 'door-closed';
export const SETTINGS_UPDATE_EVENT = 'settingsUpdated';
export const MAPPING_ACTION_STATE = {
  lockeddown: 'reclaim',
  loaded: 'pickup',
  ordered: 'delivery',
  ready: 'delivery',
  preparing: 'delivery',
};
export const EOL_HOST = 'http://192.168.100.1:1880/ui';
export const CONFIG_ITEMS = [
  {
    label: 'setup.serviceMode',
    icon: '/assets/service.svg',
    nav: 'service',
  },
];
export const VALID_IP_REGEX =
  /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
export const VALID_MASK_ADDRESS = [
  '0.0.0.0',
  '128.0.0.0',
  '192.0.0.0',
  '224.0.0.0',
  '240.0.0.0',
  '248.0.0.0',
  '252.0.0.0',
  '254.0.0.0',
  '255.0.0.0',
  '255.128.0.0',
  '255.192.0.0',
  '255.224.0.0',
  '255.240.0.0',
  '255.248.0.0',
  '255.252.0.0',
  '255.254.0.0',
  '255.255.0.0',
  '255.255.128.0',
  '255.255.192.0',
  '255.255.224.0',
  '255.255.240.0',
  '255.255.248.0',
  '255.255.252.0',
  '255.255.254.0',
  '255.255.255.0',
  '255.255.255.128',
  '255.255.255.192',
  '255.255.255.224',
  '255.255.255.240',
  '255.255.255.248',
  '255.255.255.252',
];
export enum HeadingStatus {
  None = '',
  Active = 'active',
  Delete = 'delete',
  Disabled = 'disabled',
}
export enum HeadingActionType {
  None = '',
  Button = 'button',
  Indicator = 'indicator',
}
export const NETWORK_ENDPOINT = 'network';
export enum VIEW_CALLING {
  OPEN_DOOR = 'opening-door',
  LOADING_ORDER = 'loading-order',
  RECLAIM_ORDER = 'reclaiming-order',
  RECLAIM_ALL_ORDER = 'reclaiming-all-order',
  DISPENSE_ORDER = 'dispensing-order',
  LOCKDOWN_ORDER = 'lockdown-order',
  VERIFY_ORDER = 'verifying-order',
  REMOVE_ITEM = 'remove-item',
  SELECTABLE_SPACE = 'selectable-space',
  RESET_SPACE = 'reset-space',
  DISABLE_SPACE = 'disable-space',
  ENABLE_SPACE = 'enable-space',
  EMPTY_SPACE = 'empty-space',
}
export const ENABLE_SUPPORT_TOOL = true;
export const SPACE_STATES = {
  FILL: 'filled',
  UNFILL: 'unfilled',
  AVAILABLE: 'available',
  DISABLE: 'disabled',
  ENABLE: 'enabled',
  RESERVE: 'reserved',
  OPEN: 'open',
  CLOSE: 'close',
} as const;

export enum ICONS {
  HOME_ACTIVE = '/assets/home-active.svg',
  HOME = '/assets/home.svg',
  HOME_DISABLED = '/assets/home-disabled.svg',
  HELP_ACTIVE = '/assets/help-active.svg',
  HELP = '/assets/help.svg',
  HELP_DISABLED = '/assets/help-disabled.svg',
  SETUP_ACTIVE = '/assets/setup-active.svg',
  SETUP = '/assets/setup.svg',
  ARROW_RIGHT = '/assets/arrow-right.svg',
  ARROW_LEFT = '/assets/arrow-left.svg',
  STATUS_ACTIVE = '/assets/status-active.svg',
  STATUS = '/assets/status.svg',
  SUPPORT_TOOL = '/assets/support-tool.svg',
  CORE_ACTIVE = '/assets/core-active.svg',
  CORE = '/assets/core.svg',
  LOGO = '/assets/logo-icon.svg',
  EMPLOYEE = '/assets/employee.svg',
  EMPLOYEE_ACTIVE = '/assets/employee-active.svg',
}
export const ORDERS_TO_DISPENSE_EVENT = 'orders-to-dispense';
export const DEVICE_UPDATE_EVENT = 'updateDeviceEvent';
export const ORDER_ID_LENGTH_MSG = 'Order ID is too short or long';
export const SCHEDULE_DISPENSED = 'schedule-dispensed';
export const ALPHA_LAYOUT_DEFAULT = [
  '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
  '{tab} q w e r t y u i o p [ ] \\',
  "{lock} a s d f g h j k l ; ' {enter}",
  '{shift} z x c v b n m , . / {shift}',
  '{space}',
];
export const ALPHA_LAYOUT_SHIFT = [
  '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
  '{tab} Q W E R T Y U I O P { } |',
  '{lock} A S D F G H J K L : " {enter}',
  '{shift} Z X C V B N M < > ? {shift}',
  '{space}',
];
export const ALPHA_LAYOUT_DISPLAY = {
  '{bksp}': '←',
  '{tab}': '⇥',
  '{lock}': '⇪',
  '{enter}': '↲',
  '{shift}': '⇧',
  '{space}': ' ',
};

export const CODE_NOT_FOUND = 'The code has not been found';

export const WRONG_STATE_MSG = `doesn't exist from the state`;
export const ALPHA_MSG = 'alphanumeric';
export const ALREADY_EXISTS_MSG = 'already exists';
export const CHARACTERS_LONG_MSG = 'characters long';
export const ORDER_ID_IN_USE_MSG = 'Order ID already in use. Try another';
export const YOUR_ORDER_IS_LOADED = 'Your Order Is Loaded';
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_STORAGE_KEY = 'frodo.language';
export const OVERFLOW_AREA_SPACE_ID = 'overflow-area';
export const MODAL_OPTIONS_OVERFLOW = {
  cancel: 'cancel',
  complete: 'complete',
};
export const LOADED_ORDERS_EVENT = 'schedule-loaded';
export enum ACTION_TYPES {
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
  RECLAIM = 'reclaim',
}
export enum RETAIL_PATHS {
  DELIVERY_OPTIONS = 'delivery-options',
  SIZE_SELECTOR = 'size-selector',
  COMPARTMENT_INDICATOR = 'compartment-indicator',
  WELCOME = 'welcome',
  CORE = 'core',
  CREATE_ORDER = 'create-order',
  ENTER_SCAN_CODE = 'enter-scan-codes',
}
export const TOUCHSCREEN_TEMPLATE = {
  hardwareInfo: {
    size: '',
    position: '',
  },
};

export const TOUCHSCREEN_LOCKERS_CLASSES = {
  Z13M: 'touchscreenZ13M',
  Z3M: 'touchscreenZ3M',
};

export const TOUCHSCREEN_LENGTH_TYPES = {
  LOCKER_LENGTH: [3, 13],
};

export const VALID_STATES = ['loaded', 'loadedVerify', 'verify', 'lockeddown'];

export const INTERMEDIATE_STATES = ['loading', 'dispense', 'reclaim'];

export const DISPENSE_STATES = {
  ORDERED: 'ordered',
  LOADING: 'loading',
  LOADED: 'loaded',
  LOADED_VERIFY: 'loadedVerify',
  DISPENSE: 'dispense',
  DISPENSED: 'dispensed',
  LOCKEDDOWN: 'lockeddown',
  RECLAIM: 'reclaim',
  REMOVE: 'remove',
  REMOVED: 'removed',
  RECLAIMED: 'reclaimed',
  CANCELLED: 'cancelled',
  READY: 'ready',
};
export type DISPENSE_STATE = (typeof DISPENSE_STATES)[keyof typeof DISPENSE_STATES];

export const ACTIONS_LOCKER_SPACES = {
  SELECT: 'selectable',
  RESET: 'reset',
  VERIFY: 'verify',
};

export const EMPTY_PRESENCE_STATE = 'empty';
export const LOCKDOWN_ORDER_STATE = 'lockdown';
export const CLOSED_SECURE_SPACE_STATE = 'closed';

export const DISPENSE_ACTIONS = {
  DO_REMOVE: 'DO_REMOVE',
  DO_RECLAIM: 'DO_RECLAIM',
  DO_DISPENSE: 'DO_DISPENSE',
  DO_LOCKEDDOWN: 'DO_LOCKEDDOWN',
  DO_VERIFY: 'DO_VERIFY',
  DO_TRANSACTION: 'DO_TRANSACTION',
  FINISH_DISPENSE: 'FINISH_DISPENSE',
  FINISH_RECLAIM: 'FINISH_RECLAIM',
  DO_CANCELLED: 'DO_CANCELLED',
  DO_UNDO: 'DO_UNDO',
  DO_LOAD: 'DO_LOAD',
  DO_HANDOFF: 'DO_HANDOFF',
};

export const SPACE_ACTIONS = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
  DISABLE: 'DISABLE',
  ENABLE: 'ENABLE',
  FILL: 'FILL',
  UNFILL: 'UNFILL',
  RESERVE: 'RESERVE',
  RELEASE: 'RELEASE',
};

export const SIDES = {
  FRONT: 'FRONT',
  REAR: 'REAR',
};

export enum BUTTON_POSITION {
  UpLeft = 'up-left',
  UpRight = 'up-right',
  Down = 'down',
}

export enum SPACE_DIRECTION {
  Next = 'next',
  Previous = 'previous',
}

export const TXPROCESS = 'timeout';

export enum REAR_PATHS {
  CREATE_ORDER_BY_PHONE = 'create-order-by-phone',
  CREATE_ORDER = 'create-order',
  DELIVERY_LIST = 'delivery-list',
  HOME = 'home',
  SIZE_SELECTOR = 'size-selector',
  LOADING_ORDER = 'loading-order',
  PROCESSING_ORDER = 'processing-order',
  LOAD_CONFIRMATION = 'load-confirmation',
}

export enum FRONT_PATHS {
  ASSOCIATE_ID = 'associate-id',
  WELCOME = 'welcome',
  CREATE_ORDER = 'create-order',
  DELIVERY_LIST = 'delivery-list',
  DELIVERY_OPTIONS = 'delivery-options',
  SIZE_SELECTOR = 'size-selector',
  LOADING_ORDER = 'loading-order',
  GUIDED_LOADING_ORDER = 'guided-loading-order',
  PROCESSING_ORDER = 'processing-order',
  LOAD_CONFIRMATION = 'load-confirmation',
}

export enum TTW_PATHS {
  DISPENSING_ORDER = 'dispensing-order',
  PICKUP_ORDER = 'pickup-order',
}

export const GENERATE_CODE_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789';

export const enum COMMON_PATHS {
  DELIVERY_PROVIDER = 'delivery-provider',
  WELCOME = 'welcome',
  HANDED_OFF_CONFIRM = 'handed-off-confirm',
  HANDED_OFF_REASON = 'handed-off-reason',
}

export const MENU_URLS = ['setup', 'help-center', 'status', 'password', ''];

export enum SETUP_PATHS {
  CONFIGURATION = 'configuration',
}

export const CODE_TYPES = {
  ALPHANUMERIC: 'alphanumeric' as const,
  NUMERIC: 'numeric' as const,
};

export type CodeType = typeof CODE_TYPES.ALPHANUMERIC | typeof CODE_TYPES.NUMERIC;

export const DEVICE_VIEW_CONTEXT_MAP = {
  [DEVICE_TYPES.NEXT_UP]: VIEW_TYPES.RETAIL,
  [DEVICE_TYPES.ORDER_HQ_FRONT]: VIEW_TYPES.FRONT_LOADING,
  [DEVICE_TYPES.ORDER_HQ_REAR]: VIEW_TYPES.REAR_LOADING,
  [DEVICE_TYPES.ORDER_HQ_FLEX]: VIEW_TYPES.REAR_LOADING,
  [DEVICE_TYPES.ARRAY_FL]: VIEW_TYPES.FRONT_LOADING,
  [DEVICE_TYPES.ARRAY_RL]: VIEW_TYPES.REAR_LOADING,
} as const;

export const CODE_ALPHANUMERIC_REGEX = /^[A-Za-z0-9]*$/;
export const KEY_ALPHANUMERIC_REGEX = /^[a-z0-9]$/i;
export const SIMPLE_KEYBOARD_SPECIAL_KEY_REGEX = /^\{.*\}$/;

export {
  CLOUD_HOST,
  FRODO_API_HOST,
  FRODO_API_WS_PATH,
  FRODO_DEVICE_SN,
  GANDALF_HOST,
  GANDALF_SEND_MESSAGE_HOST,
  HEALTH_CHECK_TIMEOUT,
  HELMSDEEP_HOST,
  MAX_USE_ADD_COMPARTMENT,
  RUN_MODE,
  UMP_HOST,
  UMP_POLL_INTERVAL_MS,
  UMP_REQUEST_TIMEOUT_MS,
} from 'src/environments/runtime';

export const KILL_SWITCH_MODE = {
  WARNING: 'warning',
  ON: 'on',
  OFF: 'off',
} as const;

export const SCHEDULE_CODE_TYPES = {
  LOAD_CODE: 'loadCode',
  CLIENT_CODE: 'clientCode',
  RECLAIM_CODE: 'reclaimCode',
} as const;

export const VALID_REAR_CODE_TYPES = [SCHEDULE_CODE_TYPES.LOAD_CODE] as const;
export const VALID_FRONT_CODE_TYPES = [SCHEDULE_CODE_TYPES.LOAD_CODE] as const;
export const VALID_RETAIL_CODE_TYPES = [
  SCHEDULE_CODE_TYPES.LOAD_CODE,
  SCHEDULE_CODE_TYPES.CLIENT_CODE,
  SCHEDULE_CODE_TYPES.RECLAIM_CODE,
] as const;
